import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { Text } from 'foundations-components/components/Text';
import ObjectTypeLabel from 'flow-doctor-lib/components/common/ObjectTypeLabel';
import UserNameLabel from 'flow-doctor-lib/components/common/UserNameLabel';
import LabelAndSubInfo from 'flow-doctor-lib/components/timeline/labels/LabelAndSubInfo';
import { getRevisionUrl } from 'flow-doctor-lib/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FlowRevisionTimelineItemLabel = ({
  logItem
}) => {
  const updateCopy = /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: `flow-doctor-lib.flows.objectLifecycle.flowRevisionHistory.label.${logItem.data.primaryAuditEventType}`
  });
  const mainCopy = logItem.data.userId ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "flow-doctor-lib.flows.objectLifecycle.flowRevisionHistory.withUser_jsx",
    elements: {
      UserNameLabel
    },
    options: {
      workflowUpdate: updateCopy,
      userId: logItem.data.userId
    }
  }) : updateCopy;
  const enrollDecision = logItem.data.metadata && logItem.data.metadata.enrollExistingDecision;
  const revisionForTimestamp = logItem.data.revisions.find(revision => revision.timestamp === logItem.data.timestamp);
  const revisionLink = revisionForTimestamp ? /*#__PURE__*/_jsx(UILink, {
    external: true,
    href: getRevisionUrl({
      portalId: revisionForTimestamp.portalId,
      flowId: revisionForTimestamp.flowId,
      version: revisionForTimestamp.version,
      isEventTriggers: revisionForTimestamp.flow.enrollmentTrigger === 'EVENT'
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.flows.objectLifecycle.flowRevisionHistory.viewWorkflowRevision"
    })
  }) : null;
  return /*#__PURE__*/_jsx(LabelAndSubInfo, {
    label: /*#__PURE__*/_jsxs(UITruncateString, {
      children: [mainCopy, /*#__PURE__*/_jsx(Text, {
        marginInlineStart: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.objectLifecycle.flowRevisionHistory.revision",
          options: {
            count: logItem.data.revisions.length < 3 ? 1 : logItem.data.revisions.length - 1,
            lastRevision: logItem.data.revisions[0].version,
            firstRevision: logItem.data.revisions[logItem.data.revisions.length - 1].version
          }
        })
      })]
    }),
    subInfoBullets: [enrollDecision && enrollDecision !== 'NOT_APPLICABLE' && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx("i", {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: enrollDecision === 'ENROLLED' ? 'flow-doctor-lib.flows.objectLifecycle.flowRevisionHistory.enrolledExisting_jsx' : 'flow-doctor-lib.flows.objectLifecycle.flowRevisionHistory.didNotEnrollExisting_jsx',
          elements: {
            ObjectTypeLabel
          },
          options: {
            portalId: logItem.data.revisions[0].portalId,
            objectTypeId: logItem.data.revisions[0].flow.objectTypeId,
            plural: true
          }
        })
      })
    }), revisionLink]
  });
};
export default FlowRevisionTimelineItemLabel;